module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_desktop_6d74476936f7c10147350f01c3f9c668.png";